<template>
  <div>
    <div v-for="(item, index) in tour.shipping_sizes" :key="index">
      <b-badge class="mr-1" variant="dark">{{index}}</b-badge>
      <span
        v-translate="{count: item}"
        :translate-n="item"
        translate-plural="%{ count } shipments"
      >%{ count } shipment
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToursListItemShippingSizes',
  props: {
    tour: {
      type: Object,
      default: () => {},
      required: true
    }
  }
}
</script>
